"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Pagination = _interopRequireDefault(require("../../preact-components/pagination/Pagination"));

var PaginationComponent = function PaginationComponent(_ref) {
  var pagination = _ref.pagination,
      _onPageChange = _ref.onPageChange,
      _onPageSizeChange = _ref.onPageSizeChange,
      displayListUpwards = _ref.displayListUpwards;
  return (0, _preact.h)(_Pagination.default, {
    displayListUpwards: displayListUpwards,
    currentPage: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 0,
    total: (pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0,
    pageSize: (pagination === null || pagination === void 0 ? void 0 : pagination.pageSize) || 0,
    pageSizes: (pagination === null || pagination === void 0 ? void 0 : pagination.pageSizes) || [25, 50, 100, 500, 1000],
    onPageChange: function onPageChange(page) {
      return _onPageChange === null || _onPageChange === void 0 ? void 0 : _onPageChange(page);
    },
    onPageSizeChange: function onPageSizeChange(pageSize) {
      return _onPageSizeChange === null || _onPageSizeChange === void 0 ? void 0 : _onPageSizeChange(pageSize);
    }
  });
};

var _default = PaginationComponent;
exports.default = _default;